import { useContext, useDebugValue } from "react";
import CaregiverContext from "../context/CaregiverProvider";

const useCg = () => {
    // const { caregiver } = useContext(CaregiverContext);
    // useDebugValue(auth, auth => auth?.circles ? "With Circle" : "Without Circle")
    return useContext(CaregiverContext);
}

export default useCg;